import React from 'react';

export function Danger(props) {
    return (
        <div style={{ backgroundImage: "none", ...props.style }} className="alert alert-danger">
            {props.children}
        </div>    
    );
}

Danger.defaultProps = {
    style: {}
}


// WEBPACK FOOTER //
// ./src/components/GenericComponets/Danger.js